import React, { useEffect, useState } from "react";
import { Loader, Confirm, Button, Icon } from "semantic-ui-react";
import { Room } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { CustomTable, BasicModal } from "../../../Shared";
import { LiveClassForm } from "../LiveClassForm";

const liveClassController = new Room();

export function ListLiveClass(props) {
  const { 
    reload, 
    onReload, 
    status = "", 
    search = "", 
    currentPage = 1, 
    setCurrentPage, 
    limit = 10, 
    onItemsPerPageChange 
  } = props;
  const { accessToken } = useAuth();
  const [rooms, setRooms] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [liveClassActive, setLiveClassActive] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const onOpenCloseModal = (row) => {
    setLiveClassActive(row);
    setShowModal((prev) => !prev);
  };

  useEffect(() => {
    async function fetchRooms() {
      setLoading(true);
      try {
        const params = {
          status: status || undefined,
          search: search || undefined,
          page: currentPage,
          limit: limit,
          orderBy: "scheduledAt",
          orderDirection: "DESC",
        };
        const res = await liveClassController.getRooms(accessToken, params);
        setRooms(res.data);
        setPagination(res.pagination);
      } catch (err) {
        setRooms([]);
        setPagination({});
      }
      setLoading(false);
    }
    fetchRooms();
  }, [accessToken, reload, status, search, currentPage, limit]);

  const onOpenCloseConfirm = (row) => {
    setLiveClassActive(row);
    setShowConfirm(!showConfirm);
  };

  const handleConfirm = () => {
    onDelete(liveClassActive);
    setShowConfirm(false);
  }

  const onDelete = async (room) => {
    setLoading(true);
    try {
      await liveClassController.deleteRoom(accessToken, room.id);
      onReload();
      onOpenCloseConfirm();
    } catch (err) {
      // Manejo de error opcional
    }
    setLoading(false);
  };

  const tableConfig = {
    headers: [
      "Nombre",
      "Descripción",
      "Fecha y Hora",
      "Duración (min)",
      "Acceso",
      "Clase en vivo",
      "Acciones",
    ],
    fields: [
      { field: "name", dataType: "text" },
      { field: "description", dataType: "text" },
      {
        field: "scheduledAt",
        dataType: "date",
        format: "DD/MM/YYYY hh:mm a",
        align: "center",
      },
      { field: "durationMinutes", dataType: "text", align: "center" },
      { field: "accessCode", dataType: "text", align: "center" },
      {
        field: "meetingUrl",
        dataType: "custom",
        component: ({ row }) => {
          // URL para la clase en vivo
          let url = row.meetingUrl;
          
          // Si no hay URL directa pero hay código de acceso, construir URL de JaaS
          if (!url && row.accessCode) {
            url = `https://8x8.vc/edunova/${row.accessCode}`;
          }
          
          return url ? (
            <Button
              as="a" 
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              icon 
              labelPosition="left"
              color="green"
              size="small"
            >
              <Icon name="video camera" />
              Entrar a clase
            </Button>
          ) : (
            <span>No disponible</span>
          );
        },
        align: "center",
      },
      {
        buttons: [
          {
            color: "blue",
            icon: "edit",
            placeholder: "Editar",
            onClick: onOpenCloseModal,
          },
          {
            color: "red",
            icon: "trash",
            placeholder: "Eliminar",
            onClick: onOpenCloseConfirm,
          },
        ],
        align: "center",
      },
    ],
    columnWidths: ["15%", "20%", "10%", "10%", "10%", "20%", "10%"],
  };

  return (
    <>
      <div className="live-class__list">
        <CustomTable
          tableConfig={tableConfig}
          data={rooms}
          pagination={pagination}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          onItemsPerPageChange={onItemsPerPageChange}
          bordered
          hover
          striped
          loading={loading}
        />
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={liveClassActive ? "Editar clase en vivo" : "Crear clase en vivo"}
      >
        <LiveClassForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          liveClass={liveClassActive}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={handleConfirm}
        content={`¿Eliminar la clase en vivo "${liveClassActive?.name || ''}"?`}
        size="mini"
      />
    </>
  );
}
